import { render } from "./MusicPlayer.vue?vue&type=template&id=6a43fc2c&scoped=true"
import script from "./MusicPlayer.vue?vue&type=script&lang=js"
export * from "./MusicPlayer.vue?vue&type=script&lang=js"

import "./MusicPlayer.vue?vue&type=style&index=0&id=6a43fc2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a43fc2c"]])

export default __exports__